import type { Theme } from "@mui/material"
import { RankedBarTableSortDirection } from "./rankedBarTable.model"

export const getDefaultBgColor = (theme: Theme) => theme.palette.common.ghostBlue

interface GetBarProgressArgs {
  value: number
  valueRange: { min: number; max: number }
  sortDirection: RankedBarTableSortDirection
}

/**
 * Bar length (in %) of a row, proportional to its position on the [min, max]
 * scale. `sortDirection` tells which end of the scale gets a full bar, so that
 * bars always shrink from the first row of the list to the last one.
 * A single-valued range gives every row a full bar.
 */
export const getBarProgress = ({
  value,
  valueRange: { min, max },
  sortDirection,
}: GetBarProgressArgs) => {
  if (max <= min) return 100
  const ratio =
    (sortDirection === RankedBarTableSortDirection.ASC ? max - value : value - min) /
    (max - min)
  return Math.min(Math.max(ratio, 0), 1) * 100
}

/** Smallest and largest values in the list, used to scale progress bars linearly */
export const getValueRange = (list?: { value: number }[]) => {
  if (!list || list.length === 0) return { min: 0, max: 0 }
  const values = list.map((item) => item.value)
  return { min: Math.min(...values), max: Math.max(...values) }
}
